<template>
  <b-modal
    id="kanbancancelmeeting"
    centered
    hide-footer
    hide-header
    :visible="showCancelMeeting"
    no-close-on-backdrop
    @hidden="closeCancelModal()"
  >
    <div class="w-100">
      <div class="d-flex p-3">
        <img
          v-if="particularJob.automatic && candidate.automaticScheduled"
          class="mb-3"
          src="@/assets/talentpool/yellowWarning.svg"
          alt
        />
        <img
          v-else
          class="mb-3"
          src="../../../assets/img/newkanban/moreoptionicons/cancelMeetings.svg"
          alt=""
        />
        <div class="w-100 mt-2 ml-2">
          <div class="d-flex justify-content-between">
            <div class="pff-modal-heading">
              Cancel
              {{
                particularJob.automatic && candidate.automaticScheduled
                  ? "Interview"
                  : "Meeting"
              }}
            </div>
            <div class="pointer" @click="closeCancelModal()">
              <img
                class="rotate-on-hover"
                src="../../../assets/img/feedbackform/x-close.svg"
                alt=""
              />
            </div>
          </div>
          <div class="mt-2 cancelmeeting-subheads">
            <span
              v-if="particularJob.automatic && candidate.automaticScheduled"
            >
              Are you sure you want to cancel the interview? This will require
              manual rescheduling.
            </span>
            <span v-else>
              Are you sure you want to cancel this meeting? <br />This action
              cannot be undone.
            </span>
          </div>
        </div>
      </div>
    </div>
    <hr
      v-if="particularJob.automatic && candidate.automaticScheduled"
      class="my-0"
    />
    <div
      class="
        d-flex
        align-items-center
        justify-content-end
        p-2
        bluebtn
        mt-2
        mb-2
        mr-2
      "
    >
      <b-button
        class="acs-cancelBtn-modal w-105px mr-3"
        @click="closeCancelModal()"
        >{{
          particularJob.automatic && candidate.automaticScheduled
            ? "Cancel"
            : "No"
        }}</b-button
      >
      <div class="position-relative">
        <b-button
          class="acs-addBtn-modal"
          @click="LoaderStatus ? '' : checkAndRemove()"
          :class="
            !LoaderStatus
              ? 'pointer'
              : particularJob.automatic && candidate.automaticScheduled
              ? 'confirm-loader-class defaultCursor'
              : 'yes-loader-class defaultCursor'
          "
        >
          {{
            LoaderStatus
              ? ""
              : particularJob.automatic && candidate.automaticScheduled
              ? "Confirm"
              : "Yes"
          }}</b-button
        >
        <div
          v-if="LoaderStatus"
          :class="
            particularJob.automatic && candidate.automaticScheduled
              ? 'confirm-loader-pos'
              : 'yes-loader-pos'
          "
        >
          <Loader />
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { mapGetters } from "vuex";
import toast from "../../mixin/toast";
import Loader from "../../../components/fixedcomponents/Loader.vue";
import scheduleMixin from "../../../components/Kanban/modal/scheduleMixin";
import {
  cancelmeeting,
  getScheduledInterview,
} from "../../../utils/apiFunctions";
export default {
  name: "CancelMeeting",
  props: {
    showCancelMeeting: Boolean,
    candidate: Object,
    particularJob: Object,
  },
  data() {
    return {
      LoaderStatus: false,
      ScheduleInterview: {},
    };
  },
  computed: {
    ...mapGetters("userVUEX", {
      roleValues: "getRoleValues",
      thirdPartyData: "getThirdPartyData",
    }),
  },
  components: {
    Loader,
  },
  mixins: [toast, scheduleMixin],
  created() {
    this.type = "cancel";
    this.getScheduledDetails();
  },
  methods: {
    async checkAndRemove() {
      this.LoaderStatus = true;
      if (
        this.candidate.automaticScheduled &&
        this.candidate.interviewRequestID
      ) {
        this.interviewRequestID = this.candidate.interviewRequestID;
        await this.removeSelectedPanelSlot();
      } else if (this.ScheduleInterview.selectedOption == "Microsoft Teams") {
        await this.removeTeamsMeeting();
      } else if (this.ScheduleInterview.selectedOption == "Hire3x - VCCL") {
        await this.removeVcclMeeting();
      } else if (this.ScheduleInterview.selectedOption == "Google Meet") {
        if (!localStorage.getItem("googleToken")) {
          await this.loadGapiScript();
        } else {
          await this.deleteInterview();
          await this.cancelMeeting();
        }
      }
      if (
        this.ScheduleInterview.selectedOption != "Google Meet" &&
        this.LoaderStatus
      ) {
        await this.cancelMeeting();
      }
    },
    async cancelMeeting() {
      try {
        let payload = {
          candidateID: this.candidate.candidateID,
          jobID: this.particularJob.jobID,
          customerID: this.particularJob.customerID,
          remarks: "",
        };
        if (this.$route.name == "VendorKanban") {
          payload.vendorID = this.$route.params.vendorID;
        }
        const res = await cancelmeeting(payload);
        if (res.status == 200) {
          this.successModal("Meeting Cancelled");
          this.LoaderStatus = false;
          this.$emit("cancel-success");
          this.closeCancelModal();
        } else {
          this.LoaderStatus = false;
          this.errorModal("Something went wrong");
          this.closeCancelModal();
        }
      } catch (err) {
        this.LoaderStatus = false;
        this.closeCancelModal();
        this.errorModal("Something went wrong");
      }
    },
    closeCancelModal() {
      this.$emit("close-cancel");
    },
    async getScheduledDetails() {
      // this.LoaderStatus = true;
      const response = await getScheduledInterview(
        this.candidate.kanbanInterviewID
      );
      if (response.status == 200) {
        this.ScheduleInterview = response.data.data;
        if (response.data.data.interviewRound.meetingID) {
          this.ScheduleInterview.selectedOption = "Microsoft Teams";
        } else if (response.data.data.interviewRound.roomId) {
          this.ScheduleInterview.selectedOption = "Hire3x - VCCL";
        } else if (response.data.data.interviewRound.meetingCode) {
          this.ScheduleInterview.selectedOption = "Google Meet";
        } else {
          this.ScheduleInterview.selectedOption = "Other";
        }
        // this.LoaderStatus = false;
      } else {
        this.errorModal("Something went wrong");
      }
    },
  },
};
</script>

<style scoped>
.yes-loader-class {
  opacity: 0.5;
  height: 29px;
  width: 70px;
}

.yes-loader-pos {
  position: absolute;
  top: -55px;
  z-index: 1;
  left: -9px;
}
</style>
